/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PaymentServiceProviderR = t.interface({
  business_name: t.string,

  enabled: t.boolean,

  psp_code: t.string
});

// optional attributes
const PaymentServiceProviderO = t.partial({
  tax_code: t.string
});

export const PaymentServiceProvider = t.intersection(
  [PaymentServiceProviderR, PaymentServiceProviderO],
  "PaymentServiceProvider"
);

export type PaymentServiceProvider = t.TypeOf<typeof PaymentServiceProvider>;
